module.exports = __webpack_public_path__ + "static/media/oneTitleoneContent.3475ec74.png";